export const UserData = [
	{
		userId: 0,
		name: '김동혁',
		profileImage: 'https://example.com/profiles/janedoe.jpg',
		statusMessage: '오늘도 행복하세요!',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 1,
		name: '정수완',
		profileImage: 'https://example.com/profiles/janedoe.jpg',
		statusMessage: '오늘도 행복하세요!',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 2,
		name: '김수빈',
		profileImage: null,
		statusMessage: '새로운 책 시작하는 날!',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 3,
		name: '박상빈',
		profileImage: 'https://example.com/profiles/emilyjohnson.jpg',
		statusMessage: '커피 한 잔의 여유~',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 4,
		name: '배세인',
		profileImage: null,
		statusMessage: '열심히 살자',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 5,
		name: '정인호',
		profileImage: 'https://example.com/profiles/sarahdavis.jpg',
		statusMessage: '운동하는 날이 좋아요',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 6,
		name: '주윤지',
		profileImage: 'https://example.com/profiles/kevinwilson.jpg',
		statusMessage: '여행 가고 싶다...',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 7,
		name: '황세영',
		profileImage: null,
		statusMessage: '오늘은 집에서 휴식을',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 8,
		name: '고이주',
		profileImage: 'https://example.com/profiles/robertgarcia.jpg',
		statusMessage: '코드가 내 친구',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 9,
		name: '김대진',
		profileImage: null,
		statusMessage: '아트는 삶이다',
		email: 'john@example.com', // 이메일 포함
	},
	{
		userId: 10,
		name: '오세주',
		profileImage: 'https://example.com/profiles/jamesthomas.jpg',
		statusMessage: '좋은 음악, 좋은 생활',
		email: 'john@example.com', // 이메일 포함
	},
];

export const initialChats = [
	{ id: 1, opposite: { name: 'Alice' }, messages: [{ text: 'Hello!', sentDate: '2023-01-01' }] },
	{ id: 2, opposite: { name: 'Bob' }, messages: [{ text: 'Hi there!', sentDate: '2023-01-02' }] },
];
